import { InjectionToken, Injector, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SPINOFF_TWO_FACTOR_AUTH_DIALOG_LOADER } from './load-spinoff-two-factor-auth-dialog';
import type { SpinoffTwoFactorAuthDialogComponent, SpinoffTwoFactorAuthDialogData } from './spinoff-two-factor-auth-dialog.component';
import type { SpinoffTwoFactorAuthMethod, SpinoffTwoFactorAuthPromptResult } from './spinoff-two-factor-auth.type';

/** 검증 프롬프트 — 사용자가 인증을 마치거나 취소할 때까지 기다린다. 기본 구현은 Material 다이얼로그를 연다. */
export type SpinoffTwoFactorAuthPrompt = (
  allowedMethods: readonly SpinoffTwoFactorAuthMethod[],
) => Promise<SpinoffTwoFactorAuthPromptResult>;

/**
 * 기본 프롬프트 = 지연 로딩한 다이얼로그. 테스트·특수 화면은 이 토큰을 다른 구현으로 바꿀 수 있다.
 * `disableClose`: 바깥 클릭·ESC로 실수로 닫혀 사용자가 하던 작업이 조용히 실패하지 않게 한다 — 취소는 명시적 버튼으로만 한다.
 */
export const SPINOFF_TWO_FACTOR_AUTH_PROMPT = new InjectionToken<SpinoffTwoFactorAuthPrompt>('SPINOFF_TWO_FACTOR_AUTH_PROMPT', {
  providedIn: 'root',
  factory: () => {
    const injector = inject(Injector);
    const loadDialog = inject(SPINOFF_TWO_FACTOR_AUTH_DIALOG_LOADER);
    return async (allowedMethods) => {
      // dialog 모듈(Material dialog + CDK dialog)도 컴포넌트와 함께 처음 열 때만 받는다.
      const [DialogComponent, { MatDialog }] = await Promise.all([loadDialog(), import('@angular/material/dialog')]);
      const ref = injector
        .get(MatDialog)
        .open<SpinoffTwoFactorAuthDialogComponent, SpinoffTwoFactorAuthDialogData, SpinoffTwoFactorAuthPromptResult>(DialogComponent, {
          data: { allowedMethods },
          disableClose: true,
          width: '400px',
          maxWidth: '92vw',
        });
      return (await firstValueFrom(ref.afterClosed())) ?? { kind: 'cancelled' };
    };
  },
});
